import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root'
})
export class BreakpointsService {
  public isMobile: boolean;
  private subject = new Subject<any>();

  sendUpdatedBreakpoints() {
    this.subject.next({ isMobile: this.isMobile });
  }

  clearMessage() {
    this.subject.next();
  }

  getBreakpoints(): Observable<any> {
    return this.subject.asObservable();
  }

  constructor(breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe(['(max-width: 768px)']).subscribe(result => {
      this.isMobile = result.matches;
      this.sendUpdatedBreakpoints();
    });
  }
}
